import { render, staticRenderFns } from "./PublishTicket.vue?vue&type=template&id=6ece74e3&"
import script from "./PublishTicket.vue?vue&type=script&lang=js&"
export * from "./PublishTicket.vue?vue&type=script&lang=js&"
import style0 from "./PublishTicket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports